
// Tracks constants that are used throughout the app

export const HTS_DTL_CAL_MODES = {
  details: 'DETAILS',
  summary: 'SUMMARY'
}

/** Entry types for which certain fields/functionality are disabled in the CBP app. */
export const ENTRY_TYPES_WITH_DISABLED_FIELDS = ['31','32','34','38']

/** Returns true when the given entry type should have fields/functionality disabled. */
export function isDisabledFforEntryType(entryType) {
  return entryType != null && ENTRY_TYPES_WITH_DISABLED_FIELDS.includes(String(entryType))
}

/**
 * Returns true when IT Date / IT Number validation should be skipped for this entry type.
 * Use this helper for any IT Date or IT Number validation (FieldValidationReducer, validationForRequiredFields, etc.)
 * so skip logic stays in one place.
 */
export function shouldSkipItDateItNumberValidation(entryType) {
  return isDisabledFforEntryType(entryType)
}